import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { chooseConsent, loadConsentedScripts, needsConsent, useConsent } from '@/components/consent/consent'
import { sitePages } from '@/config/pages'

/**
 * Asks once, on every kind of page (site, legacy and nomination pages), and again from "Cookie
 * settings". Renders nothing while no optional script is configured (src/components/consent/consent.ts).
 */
export const ConsentBanner = () => {
  const { ready, choice, reviewing } = useConsent()

  // A visitor who accepted earlier gets the scripts on every page load.
  useEffect(() => {
    if (choice === 'accepted') loadConsentedScripts()
  }, [choice])

  if (!needsConsent || !ready || (choice !== null && !reviewing)) return null

  return (
    <section className="consent" aria-labelledby="consent-title">
      <h2 id="consent-title" className="consent-title">
        Cookies
      </h2>
      <p className="consent-text">
        With your consent we use optional cookies, described in our privacy policy. Decline and they never load. Visits are also
        counted by Vercel Analytics, which sets no cookies.
      </p>
      <div className="consent-actions">
        <button type="button" className="btn btn-ink btn-sm" onClick={() => chooseConsent('accepted')}>
          Accept
        </button>
        <button type="button" className="btn btn-ink btn-sm" onClick={() => chooseConsent('declined')}>
          Decline
        </button>
        <Link className="consent-link" to={`${sitePages.privacy.path}#cookies`}>
          Privacy policy
        </Link>
      </div>
    </section>
  )
}
